import type {
  CreateInventoryOrderItemReceiptInput,
  SortDirection,
} from './graphql/generated/types'
import { requestMutation, requestQuery } from './graphql/graphqlCore'
import {
  ADD_INVENTORY_ORDER_ITEM_RECEIPTS,
  UPDATE_INVENTORY_ORDER_NOTES,
} from './graphql/mutations/inventoryOrders'
import {
  FETCH_INVENTORY_ORDER_BY_ID,
  FETCH_INVENTORY_ORDERS_PAGE,
} from './graphql/queries'
import * as Schema from './schemas'

export const fetchInventoryOrders = requestQuery({
  query: FETCH_INVENTORY_ORDERS_PAGE,
  variablesHandler: (
    _businessId,
    from: number = 0,
    to: number = 25,
    filters?: Record<string, string[]>,
    orderBy?: Record<string, SortDirection>,
    query?: string,
  ) => ({
    input: {
      offset: from,
      limit: to,
      category: filters?.category,
      status: filters?.status,
      orderBy,
      query,
    },
  }),
  schema: Schema.inventoryOrdersList,
})

export const fetchInventoryOrder = requestQuery({
  query: FETCH_INVENTORY_ORDER_BY_ID,
  variablesHandler: (businessId: string, orderId: string) => ({
    id: orderId,
  }),
  schema: Schema.inventoryOrder,
})

export const addInventoryOrderItemReceipts = requestMutation({
  mutation: ADD_INVENTORY_ORDER_ITEM_RECEIPTS,
  variablesHandler: (
    businessId: string,
    orderItemId: string,
    receipts: CreateInventoryOrderItemReceiptInput[],
  ) => ({
    input: {
      orderItemId,
      receipts,
    },
  }),
})

export const updateInventoryOrderNotes = requestMutation({
  mutation: UPDATE_INVENTORY_ORDER_NOTES,
  variablesHandler: (
    businessId: string | undefined,
    orderId: string,
    notes: string | null,
  ) => ({
    input: {
      id: orderId,
      notes,
    },
  }),
  schema: Schema.inventoryOrder,
})
